// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__315Zr","desc":"style_desc__2Ip4E"};